import { Token, List, } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Option } from "@siteimprove/alfa-option";
import { Shorthand } from "../shorthand.js";
import * as Reference from "./mask-image.js";
import * as Size from "./mask-size.js";
import * as Repeat from "./mask-repeat.js";
import * as Mode from "./mask-mode.js";
import * as Position from "./mask-position.js";
import * as Origin from "./mask-origin.js";
import * as Clip from "./mask-clip.js";
import * as Composite from "./mask-composite.js";
const { doubleBar, map, option, pair, right, delimited, separatedList } = Parser;
const slash = delimited(option(Token.parseWhitespace), Token.parseDelim("/"));
const parsePosAndSize = pair(Position.parse, option(right(slash, Size.parse)));
/**
 * {@link https://drafts.fxtf.org/css-masking/#typedef-mask-layer}
 *
 * @privateRemarks
 * As of December 2024 the specification uses the <geometry-box> type in the shorthand defintion
 * whereas the longhands `mask-clip` and `mask-origin` uses <coord-box>.
 * These are not the same types - <coord-box> does not have `margin-box`.
 * There is an open PR to fix that, which we follow.
 * {@link https://github.com/w3c/fxtf-drafts/pull/552}
 */
const parse = map(doubleBar(Token.parseWhitespace, Reference.parse, parsePosAndSize, Repeat.parse, Origin.parse, Clip.parse, Composite.parse, Mode.parse), ([image, posAndSize, repeat, box1, box2, composite, mode]) => {
    const [pos, size] = posAndSize !== undefined
        ? [posAndSize[0], posAndSize[1].getOr(undefined)]
        : [undefined, undefined];
    const origin = box1;
    const clip = box2 ?? box1;
    return [image, pos, size, repeat, origin, clip, composite, mode];
});
// List.parseCommaSeparated(parse);
const parseList = separatedList(parse, delimited(option(Token.parseWhitespace), Token.parseComma));
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/mask}
 *
 * @internal
 */
export default Shorthand.of([
    "mask-image",
    "mask-position",
    "mask-size",
    "mask-repeat",
    "mask-origin",
    "mask-clip",
    "mask-composite",
    "mask-mode",
], map(parseList, (layers) => {
    const images = [];
    const positions = [];
    const sizes = [];
    const repeats = [];
    const origins = [];
    const clips = [];
    const composites = [];
    const modes = [];
    for (const layer of layers) {
        const [image, pos, size, repeat, origin, clip, composite, mode] = layer;
        images.push(image ?? Reference.initialItem);
        positions.push(pos ?? Position.initialItem);
        sizes.push(size ?? Size.initialItem);
        repeats.push(repeat ?? Repeat.initialItem);
        origins.push(origin ?? Origin.initialItem);
        clips.push(clip ?? Clip.initialItem);
        composites.push(composite ?? Composite.initialItem);
        modes.push(mode ?? Mode.initialItem);
    }
    return [
        ["mask-image", List.of(images, ", ")],
        ["mask-position", List.of(positions, ", ")],
        ["mask-size", List.of(sizes, ", ")],
        ["mask-repeat", List.of(repeats, ", ")],
        ["mask-origin", List.of(origins, ", ")],
        ["mask-clip", List.of(clips, ", ")],
        ["mask-composite", List.of(composites, ", ")],
        ["mask-mode", List.of(modes, ", ")],
    ];
}));
//# sourceMappingURL=mask.js.map